import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * Global confirmation dialog. Replaces the native `window.confirm()` with a
 * Vuetify pop-up. `confirm(options)` returns a Promise<boolean> that resolves
 * to true when the user confirms and false when they cancel/dismiss.
 */
export const useConfirmDialogStore = defineStore("confirmDialog", () => {
  const isOpen = ref(false);
  const options = ref({
    title: "Confirm",
    message: "",
    confirmText: "Confirm",
    cancelText: "Cancel",
    confirmColor: "primary",
  });

  let resolver = null;

  const confirm = (opts = {}) => {
    options.value = {
      title: "Confirm",
      message: "",
      confirmText: "Confirm",
      cancelText: "Cancel",
      confirmColor: "primary",
      ...opts,
    };
    isOpen.value = true;
    return new Promise((resolve) => {
      resolver = resolve;
    });
  };

  const settle = (result) => {
    isOpen.value = false;
    if (resolver) {
      resolver(result);
      resolver = null;
    }
  };

  const handleConfirm = () => settle(true);
  const handleCancel = () => settle(false);

  return {
    isOpen,
    options,
    confirm,
    handleConfirm,
    handleCancel,
  };
});
